/**
 * @class HTML Video
 * 
 * @method constructor
 *     @param {HTMLElement} el
 * 
 * @method playVideo
 * @method pauseVideo
 * @method setToggleText
 * @method init
 *
 * Create a video player
 */

const selectors = {
    player: '.js-video-player',
    trigger: '.js-video-trigger'
}

const classes = {
    playing: 'is-playing',
    ready: 'is-ready'
}

export default class HTMLVideo {
    constructor (el) {
        this.el = el;
        this.player = el.querySelector(selectors.player);
        this.trigger = el.querySelector(selectors.trigger);

        if (!this.player || !this.trigger) return;

        this.isPlaying = false;

        this.init();
    }

    playVideo () {
        this.player.play();
        this.el.classList.add(classes.playing);
        this.isPlaying = true;

        if (this.el.dataset.controls !== 'false') {
            this.player.controls = true;
        }
    }

    pauseVideo () {
        this.player.pause();
        this.el.classList.remove(classes.playing);
        this.isPlaying = false;
    }


    setToggleText () {
        this.label.innerText = this.isOpen ? this.toggle.dataset.closeText : this.toggle.dataset.openText;
    }

    init () {
        this.el.classList.add(classes.ready);
        this.trigger.addEventListener('click', () => {
            if (this.el.dataset.controls == 'false') return;
            this.playVideo();
        });
    }
}
